import { createServerFn } from "@tanstack/react-start";
import { loadClassPosition } from "./curb-weight-peers.server";

export const getCurbWeightClassPosition = createServerFn({ method: "GET" })
  .inputValidator((data: { makeSlug: string; modelSlug: string }) => data)
  .handler(async ({ data }) => loadClassPosition(data.makeSlug, data.modelSlug));
